/*! @azure/msal-browser v2.39.0 2024-06-06 */
'use strict';

/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.39.0";
export { name, version };